import { ReactNode } from 'react';

type SettingsGroupProps = {
  title: string;
  children: ReactNode;
};

const SettingsGroup = ({ title, children }: SettingsGroupProps) => (
  <div className='overflow-hidden rounded-[20px] border border-[#E8EAF0] bg-white'>
    <div className='border-b border-[#E8EAF0] p-5'>
      <h3 className='text-[18px] font-semibold text-main'>{title}</h3>
    </div>
    <div className='divide-y divide-[#F1F2F6]'>{children}</div>
  </div>
);

export default SettingsGroup;
